import { Box } from '@mantine/core';
import { useGetColor } from '../hooks';
import type { IconPropsType } from './types';

export const UnderlineIcon = ({
  size = 24,
  sx,
  color,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.96002 20H19.04M6.88002 4V12.32C6.88002 15.1477 9.17232 17.44 12 17.44C14.8277 17.44 17.12 15.1477 17.12 12.32V4"
        stroke={iconColor}
        strokeWidth="1.5"
      />
    </Box>
  );
};
